import { DeliveryCompany } from "../../entity/DeliveryCompany";
import { toDate } from "../../utils/GlobalFunctions";
import { DeliveryCompanyDto } from "../dto/DeliveryCompany.Dto";

export class DeliveryMapper {
  static mapToDelivery(
    deliveryCompanyDto?: DeliveryCompanyDto[],
  ): DeliveryCompany[] {
    return (
      deliveryCompanyDto?.map((deliveryCompanyDto) => {
        return {
          id: deliveryCompanyDto.id,
          name: deliveryCompanyDto.name,
          logo: deliveryCompanyDto.logo,
          createdAt: toDate(deliveryCompanyDto.createdAt),
          updatedAt: toDate(deliveryCompanyDto.updatedAt),
          isActive: deliveryCompanyDto.isActive,
          fragments: deliveryCompanyDto.fragments,
          baseUrl: deliveryCompanyDto.baseUrl,
          apiKeyLabel: deliveryCompanyDto.apiKeyLabel,
          apiSecretLabel: deliveryCompanyDto.apiSecretLabel,
          apiKeyIsRequired: deliveryCompanyDto.apiKeyIsRequired,
          apiSecretIsRequired: deliveryCompanyDto.apiSecretIsRequired,
        };
      }) || []
    );
  }
}
